export default "__VITE_ASSET__DfGPcMol__"